import { useTranslation } from "react-i18next"
import { Button, Text } from "@shopify/polaris"

import { useRedirect } from "../../../hooks"

export default function CreateSection({ experienceId }) {
    const { t } = useTranslation()
    const {redirectToLink} = useRedirect()
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Text variant="headingMd" as="h6" tone="base">
          {t('Section.List.Table.emptyState.title')}
        </Text>
        <Text variant="bodySm" as="p">
          {t('Section.List.Table.emptyState.subtitle')}
        </Text>
        <Button variant="primary" onClick={() => redirectToLink({
          url: '/sections/create?experienceId=' + experienceId
        })}>
          {t('Section.List.Table.emptyState.cta')}
        </Button>
      </div>
    )
  }